import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";
import UnknownIcon from "@material-ui/icons/Help";

export default function StateIcon({state}) {
  return state === "pending" ? (
    <CircularProgress size={20} />
  ) : state === "pass" ? (
    <CheckCircleIcon style={{color: "green"}} />
  ) : state === "fail" ? (
    <ErrorIcon style={{color: "red"}} />
  ) : (
    <UnknownIcon />
  );
}
